import { Reveal } from "@/components/site/Motion";
import { PhotoSlider } from "./PhotoSlider";

const STEPS = [
  { n: "01", t: "Si marina", d: "Sale, erbe, spezie della casa. Il pollo riposa e prende sapore." },
  { n: "02", t: "Si gira", d: "Sullo spiedo, lento, davanti al fuoco. Il grasso cola sulle patate." },
  { n: "03", t: "Si mangia", d: "Lo prendi caldo al banco o te lo porti a casa. Semplice." },
];

export const Manifesto = () => (
  <section data-testid="manifesto-section" className="mx-auto max-w-7xl px-5 sm:px-8 py-24 sm:py-36">
    <Reveal>
      <p className="eyebrow">Dal 1998 · Come lavoriamo</p>
    </Reveal>
    <div className="mt-6 grid gap-10 lg:grid-cols-12 items-end">
      <Reveal delay={0.1} className="lg:col-span-8">
        <h2 className="font-display uppercase text-4xl sm:text-6xl lg:text-7xl leading-[0.95] tracking-[-0.035em]">
          Niente fronzoli. Solo <span className="text-[#FF5500]">fuoco</span>, spiedo e il <span className="text-outline">tempo</span> giusto.
        </h2>
      </Reveal>
      <Reveal delay={0.2} className="lg:col-span-4">
        <PhotoSlider />
      </Reveal>
    </div>
    <div className="mt-20 grid gap-px bg-white/10 md:grid-cols-3 rounded-[2rem] overflow-hidden border border-white/10">
      {STEPS.map((s, i) => (
        <Reveal key={s.n} delay={i * 0.12} className="h-full">
          <div data-testid={`step-${s.n}`} className="group h-full bg-[#0D0D0F] p-8 sm:p-10 transition-colors duration-500 hover:bg-[#16161A]">
            <span className="font-display text-6xl text-white/15 transition-colors duration-500 group-hover:text-[#FF5500]">{s.n}</span>
            <h3 className="mt-10 font-display uppercase text-2xl sm:text-3xl">{s.t}</h3>
            <p className="mt-3 text-zinc-400 leading-relaxed">{s.d}</p>
          </div>
        </Reveal>
      ))}
    </div>
  </section>
);
